import React, { ComponentPropsWithoutRef, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export interface BadgeProps extends ComponentPropsWithoutRef<'span'> {
  icon?: ReactNode;
}

/** A small label with an optional icon. Colours come from the caller via `className`. */
export function Badge({
  icon, className, children, ...spanProps
}: Readonly<BadgeProps>) {
  return (
    <span
      className={twMerge(
        'inline-flex items-center gap-1 whitespace-nowrap rounded-md px-2.5 py-[7px] text-base',
        'font-bold leading-4 drop-shadow-[0_2px_1.5px_rgba(0,0,0,0.1)]',
        className,
      )}
      {...spanProps}
    >
      {icon}
      {children}
    </span>
  );
}
